/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of conditional rule.
 */
export enum FormElementConditionType {
    ANSWER_EQUALS = 'AnswerEquals',
    ANSWER_NOT_EQUALS = 'AnswerNotEquals',
    ANSWER_CONTAINS = 'AnswerContains',
    ANSWER_NOT_CONTAINS = 'AnswerNotContains',
    ANSWER_HAS_ANY_VALUE = 'AnswerHasAnyValue',
    ANSWER_HAS_NO_VALUE = 'AnswerHasNoValue',
    COUNT_EQUALS = 'CountEquals',
    COUNT_NOT_EQUALS = 'CountNotEquals',
}
